import LocalizedClientLink from "@modules/common/components/localized-client-link"

/**
 * Wordmark "Virtual Europe" — variante texto do DESIGN.md: o nome em gradiente
 * {colors.blue-400}→{colors.cyan}. Não há SVG de marca no repo ainda (Story 2.7); este é
 * o ponto único de troca quando o logotipo sair do backup WordPress.
 */
export default function Logo({ className }: { className?: string }) {
  return (
    <LocalizedClientLink
      href="/"
      aria-label="Virtual Europe — início"
      data-testid="nav-store-link"
      className={`flex items-center ${className ?? ""}`}
    >
      <span className="bg-gradient-to-r from-blue-400 to-cyan bg-clip-text text-lg font-extrabold tracking-tight text-transparent">
        Virtual Europe
      </span>
    </LocalizedClientLink>
  )
}
